export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_pt.3c37822285c202de.json"